<style>

/* *{
  border: 1px red solid;
} */

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
  max-height: 60%;
  overflow-y: auto;
}

.list{
  position: fixed;
  top: 160px;
  left: 0;
  right: 0;
  bottom: 150px;
  z-index: 2;
  overflow-y: auto;
}

.item-container{
  width: 390px;
  margin: auto;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 20px 0 20px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

button.show-all{
  border: none;
  background-color: rgba(255,255,255,0.5);
  color: black;
  width: auto;
  font-size: 20px;
}
button.show-all:hover{
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
}
.button-container{
  text-align: center;
  padding: 20px;
}

.gender{
  background-color: rgba(255,255,255,0.5);
  color: black;
}

.title-signup{
  margin-top: 50px;
}
</style>

<div class="bg">
  <div class="title-signup">What is your gender identity?</div>
  
  <div class="list" style="top: {showAll == true ? 110 : 160}px;">
    <div class="item-container">
      
      {#each genders as item}
        {#if showAllHelper(item, showAll)}
          <div class="item { gender == item.i ? 'gender' : '' }" on:click="{ () => {gender = item.i; check() } }">
            <div class="check">
              
              {#if gender == item.i}
                <i class="icon-check"></i>
              {/if}
              
            </div>
            <div class="text">{item.t}</div>
          </div>
        {/if}
      {/each}
      
      <div class="button-container">
        {#if !showAll}
          <button class="show-all" on:click="{ () => showAll = true }">Show All Identities</button>
        {/if}
      </div>
      
    </div>
  </div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Genders from "../../../../helpers/Genders.js";
const genders = Genders.gender;

import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("gender", -1);
  genderSaved = Signup.getPersonalObject("genderSaved");
  gender = Signup.getPersonalObject("gender");

  if (genderSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let showAll = false;
let gender = -1;
let genderSaved = false;
let nextDisabled = true;


function showAllHelper(item) {
  if (showAll == false && item.d == true) {
    return true;
  } else if (showAll == true) {
    return true;
  }
  
  return false;
}


function check() {
  genderSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    if (gender == -1) throw "no gender selected";
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (genderSaved == false) {
    await Signup.saveToPersonalObject("gender", gender);
    await Signup.saveToPersonalObject("genderSaved", true);
    await Signup.saveMe("gender");
  }
  
  push("/signup/profile/personal/age-preference");
}


</script>